<template>
  <div class="c-main">
    <div
      class="banner"
      :style="{
        backgroundImage: `url('${BASE_URL}${weHeader.url}')`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
      }"
    >
      <div class="about-content">
        <h2>关于我们</h2>
        <p v-html="weHeader.content">
        </p>
      </div>
    </div>
    <!-- <div class="choice">选择中模云系统</div> -->
    <div class="choiceimg">
       <div class="banner-all">
      <div class="priceImgs" v-for="(item, index) in aboutUsImgs.list" :key="index">
        <img :src="BASE_URL + item.imageUrls" v-if="item.imageUrls" />
      </div>
    </div>
    </div>
    <!-- <div class="contact-page">
      <div class="contact-container">
       
        <div class="contact-info">
          <h2>联系方式</h2>
          <h3>温州中模网络科技有限公司</h3>
          <ul class="info-list">
            <li><span>电话：</span>0577-61318188</li>
            <li><span>手机：</span>15858777800</li>
            <li><span>微信：</span>call17767372252</li>
            <li><span>邮箱：</span>123456789@fff.com</li>
            <li><span>地址：</span>浙江省乐清市天成街道宁康东路2016号C栋5楼</li>
          </ul>
          <div class="map-container">
            <img src="../../assets/map.png" alt="公司位置地图" />
          </div>
        </div>

      
        <div class="message-form">
          <h2>在线留言</h2>
          <el-form
            ref="messageForm"
            :model="form"
            :rules="rules"
            label-width="0"
          >
            <div style="margin-bottom: 12px">
              联系人<i style="color: red">*</i>
            </div>
            <el-form-item prop="linkman">
              <el-input
                v-model="form.linkman"
                placeholder="请输入您的称呼"
                prefix-icon="el-icon-user"
              />
            </el-form-item>
            <div style="margin-bottom: 12px">
              手机<i style="color: red">*</i>
            </div>
            <el-form-item prop="contactInfo">
              <el-input
                v-model="form.contactInfo"
                placeholder="请输入手机号"
                prefix-icon="el-icon-phone"
              />
            </el-form-item>
            <div style="margin-bottom: 12px">
              企业名称<i style="color: red">*</i>
            </div>
            <el-form-item prop="companyName">
              <el-input
                v-model="form.companyName"
                placeholder="请输入企业名称"
                prefix-icon="el-icon-office-building"
              />
            </el-form-item>
            <div style="margin-bottom: 12px">
              邮箱<i style="color: red">*</i>
            </div>
            <el-form-item prop="email">
              <el-input
                v-model="form.email"
                placeholder="请输入邮箱"
                prefix-icon="el-icon-message"
              />
            </el-form-item>
            <el-form-item prop="msgContent">
              <el-input
                v-model="form.msgContent"
                type="textarea"
                rows="5"
                placeholder="留言"
                prefix-icon="el-icon-edit"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm">提交留言</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
// import { getArticle } from "../../api/article";
// import ArticleItem from "../Components/ArticleItem";
import { msgInsert, getConf } from "../../api/article";

export default {
  name: "productCenter",
  data() {
    return {
      BASE_URL: process.env.VUE_APP_API_BASE_URL,
      weHeader: {content:""},
      aboutUsImgs: { list: [] },
      form: {
        linkman: "",
        contactInfo: "",
        companyName: "",
        email: "",
        message: "",
      },
      rules: {
        linkman: [
          { required: true, message: "请输入您的称呼", trigger: "blur" },
        ],
        contactInfo: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1\d{10}$/,
            message: "请输入正确的手机号格式",
            trigger: "blur",
          },
        ],
        companyName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱格式", trigger: "blur" },
        ],
      },
    };
  },
  computed: {},
  created() {},
  filters: {
    setText(val) {
      return val
        .replace(/<(p|div)[^>]*>(<br\/?>|&nbsp;)<\/\1>/gi, "\n")
        .replace(/<br\/?>/gi, "\n")
        .replace(/<[^>/]+>/g, "")
        .replace(/(\n)?<\/([^>]+)>/g, "")
        .replace(/\u00a0/g, " ")
        .replace(/&nbsp;/g, " ")
        .replace(/<img[^>]+src\\s*=\\s*['\"]([^'\"]+)['\"][^>]*>/g, "")
        .replace(/<\/?(img|table)[^>]*>/g, "") // 去除图片和表格
        .replace(/<\/?(a)[^>]*>/g, ""); //  去除a标签
    },
  },
  mounted() {
    this.fetchHomeConf();
  },
  methods: {
    async fetchHomeConf() {
      try {
        const response = await getConf();
        this.weHeader = JSON.parse(response.data.weHeader) || {};
        this.aboutUsImgs = JSON.parse(response.data.aboutUs) || { list: [] };
      } catch (error) {
        console.error("页面初始化获取配置失败", error);
      }
    },
    async submitForm() {
      this.$refs.messageForm.validate(async (valid) => {
        if (valid) {
          try {
            // 2. 构造提交参数（去除首尾空格，确保数据整洁）
            const submitParams = {
              linkman: this.form.linkman,
              contactInfo: this.form.contactInfo,
              companyName: this.form.companyName,
              email: this.form.email,
              message: this.form.message,
            };

            // 3. 调用接口提交数据
            const res = await msgInsert(submitParams);

            // 4. 接口响应处理
            if (res.code === 0) {
              this.$message({
                message: res.msg || "留言提交成功！我们将尽快与您联系",
              });
              this.$refs.messageForm.resetFields(); // 重置表单
            } else {
              this.$message.warning(res.msg || "留言提交失败，请重试");
            }
          } catch (error) {
            // 5. 异常处理（网络错误等）
            console.error("留言提交异常：", error);
            this.$message.error("网络异常，请稍后重试");
          }
        } else {
          return false; // 验证失败，不提交
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin backgroundImage($url) {
  background-image: url($url);
  background-repeat: no-repeat;
  background-size: 100%;
}

.c-main {
  min-height: calc(100vh - 100px);
  padding-bottom: 60px;
}
.banner {
  width: 100%;
  height: 450px;
  background-size: cover;
  position: relative;
}
.about-content {
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 20px;
  color: #fff;
  position: absolute;
  left: 300px;
  top: 110px;
}
.about-content h2 {
  font-size: 48px;
  font-weight: bold;
  color: #fff;
}
.about-content p {
  font-size: 16px;
  line-height: 1.8;
  margin-bottom: 16px;
}
.choice {
  font-weight: bold;
  font-size: 40px;
  color: #2b3139;
  text-align: center;
  margin-bottom: 73px;
  margin-top: 40px;
}
.choiceimg {
  width: 100%;
  line-height: 0;
}
.contact-page {
  padding: 40px 0;
  font-family: "Microsoft YaHei", sans-serif;
}

.contact-container {
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  gap: 60px;
}

.contact-info,
.message-form {
  flex: 1;
}

h2 {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #1f2329;
  padding-bottom: 10px;
  display: inline-block;
}

h3 {
  font-size: 18px;
  margin: 0 0 20px;
  color: #333;
}

.info-list {
  list-style: none;
  padding: 0;
  margin: 0 0 35px;
}

.info-list li {
  margin-bottom: 15px;
  line-height: 1.6;
  color: #666;
}

.info-list li span {
  color: #333;
  font-weight: 500;
  margin-right: 5px;
}

.map-container {
  width: 100%;
  height: 250px;
  overflow: hidden;
  border-radius: 4px;
}

.map-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.el-form {
  max-width: 500px;
}

.el-form-item {
  margin-bottom: 20px;
}

.el-button {
  width: 100%;
}

@media (max-width: 768px) {
  .contact-container {
    flex-direction: column;
    gap: 40px;
    padding: 0 20px;
  }

  .map-container {
    height: 200px;
  }
}
.banner-all {
  width: 100%;
  margin: 0 auto;
}

.priceImgs {
  width: 100%;
}

.priceImgs img {
  display: block;
  max-width: 100%;
  width: auto;
  height: auto;
  margin: 0 auto;
}
</style>
